import '../../../base_builders/vertical/rcp/rcp_base_builder';

import Author_init from  '../../../../assets/js/Authors/author';
Author_init();

import Newsletters from '../../../../assets/js/Newsletters/Newsletters';
Newsletters();
